export default __webpack_public_path__ + "static/media/illust-voryq-login-2.2e75a081.png";